'use client';

import { c as _c } from "react/compiler-runtime";
import { useTrailerViewMedia } from '@/hooks/useTrailerViewMedia';
import { createContext, PropsWithChildren, useContext } from 'react';
const TrailerViewMediaContext = createContext<ReturnType<typeof useTrailerViewMedia> | null>(null);
type TrailerViewMediaProviderProps = PropsWithChildren<{
  sendBI?: boolean;
  video?: {
    backgroundPlay?: boolean;
    containerClassName?: string;
  };
}>;
export function TrailerViewMediaProvider(t0) {
  const $ = _c(6);
  const {
    children,
    sendBI: t1,
    video
  } = t0;
  const sendBI = t1 === undefined ? true : t1;
  let t2;
  if ($[0] !== sendBI || $[1] !== video) {
    t2 = {
      sendBI,
      video
    };
    $[0] = sendBI;
    $[1] = video;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const value = useTrailerViewMedia(t2);
  let t3;
  if ($[3] !== children || $[4] !== value) {
    t3 = <TrailerViewMediaContext.Provider value={value}>{children}</TrailerViewMediaContext.Provider>;
    $[3] = children;
    $[4] = value;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
export const useTrailerViewMediaContext = () => {
  const value = useContext(TrailerViewMediaContext);
  if (value == null) {
    throw new Error("useTrailerViewMediaContext cannot be used outside of TrailerViewMediaProvider");
  }
  return value;
};